/**
 * Rôle issu du JWT (session persistée sans objet `user` après F5 / avant fetchProfile).
 */
export function decodeJwtRole(token: string | null | undefined): string | null {
  if (!token) return null;
  try {
    const part = token.split('.')[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'));
    const payload = JSON.parse(json) as { role?: unknown };
    if (typeof payload.role === 'string' && payload.role.length > 0) {
      return payload.role.toLowerCase().trim();
    }
  } catch {
    /* ignore */
  }
  return null;
}

/** Aligne les variantes backend / legacy pour les contrôles d’accès. */
export function normalizeAuthRole(role: string | null | undefined): string | null {
  if (role == null || role === '') return null;
  const r = String(role).toLowerCase().trim();
  if (r === 'institution') return 'institution_admin';
  if (r === 'collaborator') return 'collaborateur';
  return r;
}

/** Vérifie si le rôle utilisateur correspond à une des entrées (chacune normalisée). */
export function roleMatchesAllowlist(role: string | null | undefined, allowed: readonly string[]): boolean {
  const n = normalizeAuthRole(role);
  if (!n) return false;
  return allowed.some((a) => normalizeAuthRole(a) === n);
}
